import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Refund} from './refunds';

@Injectable()
export class RefundService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('refunds?' + params.toString()).map((response: Response) => response.json());
    }
    deletePic(_id: string) {
        return this.http.put('org/picture/delete/' + _id,{}).map((response: Response) => response.json());
    }
    deletePic1(_id: string) {
        return this.http.put('org/picture/delete1/' + _id,{}).map((response: Response) => response.json());
    }
    getAllCurrencies() {
        return this.http.get('all/currencies').map((response: Response) => response.json());
    }
    getLogo() {
        return this.http.get('refunds/logo').map((response: Response) => response.json());
    }

    getByIdinv(_id: string) {
      return this.http.get('purchases/' + _id).map((response: Response) => response.json());
    }

    getById(_id: string) {
      return this.http.get('refunds/' + _id).map((response: Response) => response.json());
    }


    getTrashedById(_id: string) {
        return this.http.get('refunds/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('refunds/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(returninvoice: Refund) {
        return this.http.post('refunds', returninvoice).map((response: Response) => response.json());
    }

    update(returninvoice: Refund) {
        return this.http.put('refunds/' + returninvoice.id, returninvoice).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('refunds/' + _id).map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/views/pro/refunds/refunds.service.ts